import axios from 'axios';

// import store from '@/store';
import { Notice, Modal } from 'view-design';
import queryString from 'query-string';

let urlPrefix = process.env.VUE_APP_URL;


function api({ method, url, data = {}, headers = undefined, formData = undefined, params = {}, entire = false, errorAlert = true, stringify = true }) {

  // if (!hideLoading) {
  // 加载中
  // }

  let options = {};
  let _hearders = {};

  // 上传
  if (formData) {
    if (headers) {
      _hearders = headers;
    } else {
      _hearders = {
        'Content-Type': 'multipart/form-data'
      };
    }

    options = {
      method: 'post',
      url: url,
      data: formData,
      baseURL: urlPrefix,
      params: params,
      headers: _hearders,
    };
  } else {
    if (headers) {
      _hearders = headers;
    } else {
      _hearders = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
    }

    options = {
      method: method,
      url: url,
      data: stringify ? queryString.stringify(data) : data,
      baseURL: urlPrefix,
      params: params,
      headers: _hearders

    };
  }



  return new Promise((resolve, reject) => {
    axios(options).then(response => {
      // if (!hideLoading) {
      //   Indicator.close();关闭loading
      // }

      if (entire) {
        resolve(response);
      } else {
        // 判断 正常请求返回的code 是否为0
        if (response.data.code) {
          // Message.error({
          //   content: response.data.msg,
          //   duration: 5
          // });
          Notice.error({
            title: '请求错误',
            desc: response.data.msg
          });
        } else {
          resolve(response.data);
        }
      }

    }).catch(error => {
      // if (!hideLoading) {
      // 关闭loading
      // }

      if (errorAlert) {


        if (error.response.data.errors && JSON.stringify(error.response.data.errors) != '{}') {
          let output = '';
          for (let key in error.response.data.errors) {
            output += key + ':';
            output += error.response.data.errors[key] + ';';
            // console.log(key + '---' + error.response.data.errors[key]);
          }

          Modal.error({
            title: error.response.data.msg,
            content: output,
            width: 500
          });
        } else {
          console.log(error.response.data.code)

          Notice.error({
            title: '请求错误',
            desc: error.response.data.msg
          });
        }


      }





      reject(error.response.data);
    });
  });


}


export default api;